import React, { createContext, useState } from "react";

export const LikeCountContext = createContext();

export const LikeCountProvider = ({ children }) => {
  const [likeCount, setLikeCount] = useState(0);

  const incrementLikeCount = () => {
    setLikeCount((prevCount) => prevCount + 1);
  };

  const decrementLikeCount = () => {
    setLikeCount((prevCount) => prevCount - 1);
  };

  return (
    <LikeCountContext.Provider
      value={{ likeCount, incrementLikeCount, decrementLikeCount }}
    >
      {children}
    </LikeCountContext.Provider>
  );
};
